import { Enums } from '../../models/common';
import { OpSchema } from '../../models/custom'

import { ConfigHelper, LogHelper } from '../../helpers';

// #region Consts

export const SCHEMA_SERVICE_NAME: string = 'SchemaService'
export const PROVIDER_NAME: string = 'SchemaServiceProvider'

// #endregion

export class SchemaService {
    // #region Consts

    public static get LOG_PREFIX(): string { return '[SIMAX.Component.Schema]' }

    // #endregion

    // #region Ctor

    constructor(private rootScope: ng.IRootScopeService) {
    }

    // #endregion

    // #region Methods

    public limitSchemaCount(schemas: OpSchema[]): OpSchema[] {
        if (schemas != null && schemas.length > 0) {
            const schemaCount: number = ConfigHelper.getValue(Enums.SimaxConfigSection.Schema, ConfigHelper.Key.MaxSchemaLimit)

            if (schemaCount != null) {
                schemas = schemas.slice(0, schemaCount)
            } else {
                LogHelper.log(SchemaService.LOG_PREFIX, "Unable to find schema number limit. Displaying all.")
            }
        }

        return schemas
    }

    // #endregion
}

export class SchemaServiceProvider implements ng.IServiceProvider {

    // #region IServiceProvider Implementation 

    public $get = ['$rootScope', function ($rootScope: ng.IRootScopeService) {
        return new SchemaService($rootScope)
    }]

    // #endregion
} 